import Layout from '@/layout'

const route = {
  path: '/mobilePhoneScanningCode',
  component: Layout,
  redirect: '/mobilePhoneScanningCode/index',
  alwaysShow: true, // will always show the root menu
  name: 'mobilePhoneScanningCode',
  meta: {
    title: '手机扫码',
    icon: 'diy-UbJiSkMa',
    roles: [
      'scan'
    ]
  },
  children: [
    // 手机列表
    {
      path: '/mobilePhone/index',
      component: () => import('@/views/mobilePhone/index.vue'),
      name: 'MobilePhone',
      meta: {
        title: '手机列表',
        // icon: 'component',
        roles: [
          'scan.getScanPhoneList'
        ]
      }
    },
    // 扫码记录
    {
      path: '/qRCodeList/index',
      component: () => import('@/views/QRCode/index.vue'),
      name: 'QRCodeList',
      meta: {
        title: '扫码记录',
        // icon: 'component',
        roles: [
          'scan.getScanContentList'
        ]
      }
    },
    // 公众号对应列表
    {
      path: '/correspondingAccount/index',
      component: () => import('@/views/correspondingAccount/index.vue'),
      name: 'CorrespondingAccount',
      meta: {
        title: '公众号对应列表',
        // icon: 'component',
        roles: [
          'scanNumberInfo.getList'
        ]
      }
    },
    {
      path: '/ota/index',
      component: () => import('@/views/ota/index.vue'),
      name: 'Ota',
      meta: {
        title: 'Ota升级列表',
        // icon: 'component',
        roles: [
          'scan.getOtaList'
        ]
      }
    }
  ]
}

export default route
